import { useEffect, useState } from "react";

// Header behavior for all pages:
// - `scrolled`: true once the page is scrolled (show separation/blur)
// - `hidden`: on mobile only, header slides away when scrolling down
export default function useHeaderScroll() {
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 24);
      if (window.innerWidth < 768) {
        // mobile: hide almost instantly when scrolling down (small viewports)
        if (y > 24 && y > last + 1) setHidden(true);
        else if (y < last - 1 || y <= 24) setHidden(false);
      } else {
        setHidden(false);
      }
      last = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return { scrolled, hidden };
}
